import { useContext } from 'react';
import { DataServiceContext } from '../contexts';

export const useDataServiceContext = () => {
  const context = useContext(DataServiceContext);
  return context;
};
